// src/utils/uploadEditorImage.js
const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:31000';

/**
 * Upload an image file to the server and return its public URL.
 * Consumed by the RichTextEditor via the `onImageExtracted` prop:
 *
 *   onImageExtracted={uploadEditorImage}
 *
 * @param {File} file - Image file (picked by the user or built from a pasted image)
 * @returns {Promise<string>} - Absolute URL of the uploaded image
 */
const uploadEditorImage = async (file) => {
  if (!file) throw new Error('No image file provided');

  const formData = new FormData();
  formData.append('image', file);

  const res = await fetch(`${API_BASE}/api/uploads/editor-image`, {
    method: 'POST',
    body: formData,
  });

  if (!res.ok) {
    let message = `Image upload failed (${res.status})`;
    try {
      const data = await res.json();
      if (data && data.message) message = data.message;
    } catch (_) { /* non-JSON error body */ }
    throw new Error(message);
  }

  const data = await res.json();
  if (!data || !data.url) throw new Error('Upload endpoint returned no URL');
  return data.url;
};

export default uploadEditorImage;